import { lazy, Suspense } from 'react';

import { Loading } from '../../components/ui.jsx';

/**
 * Payments in the web app: the client's saved payment methods, gateway settings for staff and the
 * "Payment methods" tab of the admin client page. The invoice page uses PayPanel.jsx directly.
 */
const pages = () => import('./pages.jsx');
const page = (name) => () => pages().then((m) => ({ Component: m[name] }));
const Tab = lazy(() => pages().then((m) => ({ default: m.ClientPaymentMethodsTab })));

function PaymentMethodsTab(props) {
  return (
    <Suspense fallback={<Loading />}>
      <Tab {...props} />
    </Suspense>
  );
}

export default {
  name: 'payments',
  clientRoutes: [{ path: 'account/payment-methods', lazy: page('PaymentMethods') }],
  adminRoutes: [{ path: 'billing/gateways', lazy: page('AdminGateways') }],
  adminNav: [
    {
      section: 'billing_settings',
      to: '/admin/billing/gateways',
      label: 'Payment gateways',
      permission: 'admin.gateways.manage',
      order: 10,
    },
  ],
  adminClientTabs: [
    {
      key: 'payment-methods',
      label: 'Payment methods',
      order: 34,
      permission: 'admin.payment_methods.read',
      Component: PaymentMethodsTab,
    },
  ],
};
